import { render, staticRenderFns } from "./ServiceDashboardListSkeleton.vue?vue&type=template&id=9d4d7916&"
var script = {}
import style0 from "./ServiceDashboardListSkeleton.vue?vue&type=style&index=0&id=9d4d7916&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports